import styled from 'styled-components';

type Props = {
  children: React.ReactNode;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

export const AgreementCheckBox = ({ children, checked, onChange, disabled }: Props): JSX.Element => {
  return (
    <Label $checked={checked}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
      {children}
    </Label>
  );
};

const Label = styled.label<{ $checked: boolean }>`
  display: block;
  padding: 0 0.375rem 0 1.625rem;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.375rem;
  position: relative;
  cursor: pointer;

  &:before {
    content: '';
    display: block;
    width: 1.125rem;
    height: 1.125rem;
    margin: auto;
    border: 1px solid ${(props) => (props.$checked ? '#eb0000' : '#0000005C')};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: ${(props) => (props.$checked ? '#eb0000' : '#fff')};
  }

  &:after {
    content: '';
    display: block;
    width: 0.75rem;
    height: 5.5px;
    margin: auto;
    border-left: 0.125rem solid ${(props) => (props.$checked ? '#fff' : '#0000005C')};
    border-bottom: 0.125rem solid ${(props) => (props.$checked ? '#fff' : '#0000005C')};
    transform: rotate(-45deg);
    position: absolute;
    top: 0;
    bottom: 0.25rem;
    left: 0.1875rem;
  }

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    overflow: hidden;
    white-space: nowrap;
  }
`;
